var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandContent = function SvgExpandContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h3q.424 0 .713.287Q6 12.576 6 13q0 .424-.287.713A.97.97 0 0 1 5 14H1a.97.97 0 0 1-.712-.287A.97.97 0 0 1 0 13V9q0-.424.288-.713A.97.97 0 0 1 1 8q.424 0 .712.287Q2 8.576 2 9zM12 2H9a.97.97 0 0 1-.713-.288A.97.97 0 0 1 8 1q0-.424.287-.712A.97.97 0 0 1 9 0h4q.424 0 .713.288Q14 .575 14 1v4q0 .424-.287.713A.97.97 0 0 1 13 6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 12 5z"
  })));
};
export default SvgExpandContent;